import {
  AfterViewInit,
  Component,
  EventEmitter,
  Injector,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Country } from '@core/enums/country.enum';
import { AppState } from '@core/store';
import { WholesaleRetailKit } from '@core/store/start-now-app/start-now-app-state-models';
import {
  resetAboutYouStep,
  resetSelectedConsultant,
  stepProcessing,
  updateWholesaleRetailSelected,
} from '@core/store/start-now-app/start-now-app.actions';
import { environment } from '@env';
import { Store } from '@ngrx/store';
import { StartNowAppStepMX } from 'app/modules/start-now-app/enums/start-now-app-step.enum';
import { StartNowStepBaseComponent } from '../../start-now-app-step-base/start-now-step-base.component';

@Component({
  selector: 'app-wholesale-retail-step',
  templateUrl: './wholesale-retail-step.component.html',
  styleUrls: ['./wholesale-retail-step.component.scss'],
})
export class WholesaleRetailStepComponent
  extends StartNowStepBaseComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  country = environment.country;
  selectedtWholeSaleRetailKit: WholesaleRetailKit;
  pageNumber: number = 1;
  onNextClicked = false;
  @Output() goToOtherStep: EventEmitter<number> = new EventEmitter<number>();
  @Output() consultantPhasePassed: EventEmitter<void> = new EventEmitter();

  titles = {
    [Country.Mexico]: $localize`Select wholesale Reatail`,
  };

  wholeSaleReatailKits: WholesaleRetailKit[] = [
    {
      id: 1,
      description: 'Wholesale',
    },
    { id: 2, description: 'Retail' },
  ];

  constructor(
    private store$: Store<AppState>,
    injector: Injector,
  ) {
    super(injector, 'SNA Step - 0.5 Wholesale Consultant');
  }

  ngOnInit(): void {
    this.selectWholesaleRetailKit(this.wholeSaleReatailKits[0]);
    this.consultantPhasePassed.emit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.store$.dispatch(resetAboutYouStep());
  }

  ngAfterViewInit(): void {
    this.selectDefaultWholeSaleRetailKit();
  }

  isSelected(
    selectedWholesaleRetailKit: WholesaleRetailKit,
    wholesaleRetailKit: WholesaleRetailKit,
  ) {
    return selectedWholesaleRetailKit?.id === wholesaleRetailKit?.id;
  }

  selectWholesaleRetailKit(selectedWholesaleRetailKit: WholesaleRetailKit): void {
    this.selectedtWholeSaleRetailKit = selectedWholesaleRetailKit;
    this.store$.dispatch(
      updateWholesaleRetailSelected({
        wholeSaleRetailSelected: this.selectedtWholeSaleRetailKit.description,
      }),
    );
  }

  public previousStepClick(): void {
    //this.store$.dispatch(resetRegistrationCodeStepSkipped());
    // this.store$.dispatch(resetFindConsultant());
    this.store$.dispatch(resetSelectedConsultant());
    this.goToOtherStep.emit(StartNowAppStepMX.DoYouKnowConsultant);
  }

  submitStep(): void {
    throw new Error('Method not implemented.');
  }

  public nextStepClick(): void {
    this.goToOtherStep.emit(StartNowAppStepMX.AboutYou);
  }

  protected createFormGroup(): FormGroup {
    throw new Error('Method not implemented.');
  }

  private selectDefaultWholeSaleRetailKit(): void {}

  private nextStep(): void {
    this.store$.dispatch(stepProcessing({ stepProcessing: false }));
    this.goToNextStep.emit();
  }
}
